import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

import AppShell from '@/components/layout/AppShell'
import AuthGuard from '@/components/auth/AuthGuard'

import SplashPage      from '@/pages/SplashPage'
import LoginPage       from '@/pages/LoginPage'
import SignUpPage      from '@/pages/SignUpPage'
import TimelinePage    from '@/pages/TimelinePage'
import CreateEntryPage from '@/pages/CreateEntryPage'
import EditEntryPage   from '@/pages/EditEntryPage'
import PrivacyPage     from '@/pages/PrivacyPage'
import CapsulesPage    from '@/pages/CapsulesPage'

import {
  DiscoverPage, NotificationsPage, ProfilePage,
  SummaryPage, VaultPage, LegacyPage, MemorialPage,
  InformPage, ChronologicalPage, SettingsPage,
} from '@/pages/OtherPages'

export default function App() {
  const { initialize, initialized, user } = useAuthStore()
  useEffect(() => { initialize() }, [initialize])

  if (!initialized) {
    return (
      <div className="min-h-dvh bg-bg flex items-center justify-center">
        <img src="/icon.png" alt="Timeline Journal" className="w-16 h-16 rounded-2xl animate-pulse" />
      </div>
    )
  }

  return (
    <Routes>
      {/* Public */}
      <Route path="/"                 element={user ? <Navigate to="/timeline" replace /> : <SplashPage />} />
      <Route path="/login"            element={user ? <Navigate to="/timeline" replace /> : <LoginPage />} />
      <Route path="/signup"           element={user ? <Navigate to="/timeline" replace /> : <SignUpPage />} />
      <Route path="/auth/callback"    element={<Navigate to="/timeline" replace />} />
      <Route path="/privacy"          element={<PrivacyPage />} />
      <Route path="/memorial/:userId" element={<MemorialPage />} />

      {/* Protected */}
      <Route element={<AuthGuard><AppShell /></AuthGuard>}>
        <Route path="/timeline"               element={<TimelinePage />} />
        <Route path="/timeline/chronological" element={<ChronologicalPage />} />
        <Route path="/timeline/create"        element={<CreateEntryPage />} />
        <Route path="/timeline/edit"          element={<EditEntryPage />} />
        <Route path="/capsules"               element={<CapsulesPage />} />
        <Route path="/discover"               element={<DiscoverPage />} />
        <Route path="/inform"                 element={<InformPage />} />
        <Route path="/summary"                element={<SummaryPage />} />
        <Route path="/vault"                  element={<VaultPage />} />
        <Route path="/legacy"                 element={<LegacyPage />} />
        <Route path="/notifications"          element={<NotificationsPage />} />
        <Route path="/profile"               element={<ProfilePage />} />
        <Route path="/profile/:userId"       element={<ProfilePage />} />
        <Route path="/settings"              element={<SettingsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
